export default function () {
  const widgetName = 'activitiesWidget';
  const widgetOpts = activitiesWidgetOpts;

  function setCharLimit(el, limit) {
    const text = el.text();
    return text.length > limit ? `${text.substring(0, limit)}...` : text;
  }
  function modifyTitle() {
    const item = $(`#${widgetName} .card-widget-item`);
    item.each(function () {
      const title = $(this).find('.card-widget-title');
      $(this).append(title);
      const origialTitle = title.text();
      title.text(setCharLimit(title, 24));
      if (title.text().length > 24) {
        title.attr('title', origialTitle);
      }
      const description = $(this).find('.card-widget-description');
      const originalDescription = description.text();
      description.text(setCharLimit(description, 90));
      if (description.text().length > 90) {
        description.attr('title', originalDescription);
        $(this).find('.buttonwrap a').css('margin-bottom', '2rem');
      }
      $(this).find('.buttonwrap a').addClass('button');
    });
  }
  // remove the first .card-widget-item

  function setBackground(data) {
    $(`#${widgetName} .card-widget-item:first-child`).remove();
    const background = data.items[0].ImageWithPath;
    const section = $('.activities-section');
    section.css('background-image', `url('${background}')`);
  }
  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data, owl, hasData) {
      modifyTitle();
      setBackground(data);
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 9,
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
